import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import HeaderButtons from './components/headerButtons/component';
import HeaderButtonsResponsive from './components/headerButtonsResponsive/component';
import UserMenu from './components/global/user-menu-component';
import FeaturedListings from './components/listings/featured-listings-component';
import ExtendedStayListings from './components/listings/extended-stay-listings-component';
import DestinationMapComponent from './components/global/destination-map-component';
import DestinationAutosuggest from './components/destination-autosuggest/component';
import CheckInPicker from './components/checkInCheckoutPicker/checkInPicker';
import CheckOutPicker from './components/checkInCheckoutPicker/checkOutPicker';
import GuestsQuantity from './components/guestsQuantity/component';
import GoToSearch from './components/goButton/component';
import LandingBanners from './components/landingBanners/component';
import RelevantListings from './components/relevantListing/RelevantListings';
import ViewFeaturedListingsButton from './components/viewFeaturedListingsButton/component';
import ListYourProperty from './components/listYourProperty/component';

import { store } from "./store.js";
import { router } from "./router.js";

import "./main.scss";

//Load the main React App
let cwApp = document.getElementById("cw-app");
if (cwApp) {
  document.title = "College Weekends";
  ReactDOM.render(
    <Provider store={store}>
      {router}
    </Provider>,
    cwApp
  );
}

//header buttons container
let headerButtonsContainer = document.getElementById("header-buttons");
if (headerButtonsContainer) {
  ReactDOM.render(<Provider store={store}><HeaderButtons /></Provider>, headerButtonsContainer);
}

//list your property container
let listYourPropertyContainer = document.getElementById("cw-list-your-property");
if (listYourPropertyContainer) {
  ReactDOM.render(<Provider store={store}><ListYourProperty /></Provider>, listYourPropertyContainer);
}

//list your property container
let listYourPropertyResponsiveContainer = document.getElementById("cw-list-your-property-responsive");
if (listYourPropertyResponsiveContainer) {
  ReactDOM.render(<Provider store={store}><ListYourProperty isResponsive={true} /></Provider>, listYourPropertyResponsiveContainer);
}


//header buttons responsive container
let headerButtonsResponsiveContainer = document.getElementById("header-buttons-responsive");
if (headerButtonsResponsiveContainer) {
  ReactDOM.render(<Provider store={store}><HeaderButtonsResponsive /></Provider>, headerButtonsResponsiveContainer);
}

//Load the user widget
let userMenuContainer = document.getElementById("user-menu");
if (userMenuContainer) {
  ReactDOM.render(<Provider store={store}><UserMenu /></Provider>, userMenuContainer);
}

//Load Featured Listings View All
let viewFeaturedListingsContainer = document.getElementById("cw-featured-listings-redirection");
if (viewFeaturedListingsContainer) {
  ReactDOM.render(<Provider store={store}><ViewFeaturedListingsButton /></Provider>, viewFeaturedListingsContainer);
}

//Load Featured Listings
let featuredListingsContainer = document.getElementById("cw-featured-listings");
if (featuredListingsContainer) {
  ReactDOM.render(<Provider store={store}><FeaturedListings /></Provider>, featuredListingsContainer);
}

//Load Extended Stay Listings
let extendedStayListingsContainer = document.getElementById("cw-extended-stay-listings");
if (extendedStayListingsContainer) {
  ReactDOM.render(<Provider store={store}><ExtendedStayListings /></Provider>, extendedStayListingsContainer);
}

//Load Featured Listings
let featuredListingsGridContainer = document.getElementById("cw-featured-listings-grid");
if (featuredListingsGridContainer) {
  ReactDOM.render(<Provider store={store}><FeaturedListings isGrid /></Provider>, featuredListingsGridContainer);
}

//Load Destination Map
let mapContainer = document.getElementById("cw-local-attractions");
if (mapContainer) {
  ReactDOM.render(<Provider store={store}><DestinationMapComponent /></Provider>, mapContainer)
}

//Load Destination Autosuggest
let destinationAutosuggestContainer = document.getElementById("location-input");
if (destinationAutosuggestContainer) {
  ReactDOM.render(<Provider store={store}><DestinationAutosuggest /></Provider>, destinationAutosuggestContainer)
}

//Load Check-In Picker
let checkInPickerContainer = document.getElementById("checkin-input");
if (checkInPickerContainer) {
  ReactDOM.render(<Provider store={store}><CheckInPicker /></Provider>, checkInPickerContainer)
}

//Load Check-Out Picker
let checkOutPickerContainer = document.getElementById("checkout-input");
if (checkOutPickerContainer) {
  ReactDOM.render(<Provider store={store}><CheckOutPicker /></Provider>, checkOutPickerContainer)
}

//Load Guests Quantity Picker
let guestsQuantityPickerContainer = document.getElementById("guests-input");
if (guestsQuantityPickerContainer) {
  ReactDOM.render(<Provider store={store}><GuestsQuantity /></Provider>, guestsQuantityPickerContainer)
}

//Load Go to search
let goToSearchContainer = document.getElementById("go-button");
if (goToSearchContainer) {
  ReactDOM.render(<Provider store={store}><GoToSearch /></Provider>, goToSearchContainer)
}

//Load Fadeable Banners
let bannersContainer = document.getElementById("landing-banners");
if (bannersContainer) {
  ReactDOM.render(<Provider store={store}><LandingBanners /></Provider>, bannersContainer)
}

//Load Relevant Listings
let relevantListingsContainer = document.getElementById("relevant-listings");
if (relevantListingsContainer) {
  ReactDOM.render(<Provider store={store}><RelevantListings /></Provider>, relevantListingsContainer)
}

